import style from './ConnectBlockSubscribe.module.scss';

export type ConnectBlockSubscribeType = {
  email?: string;
  pinterestLink: string;
  instagramLink: string;
  facebookLink: string;
  linkedinLink: string;
};
export const ConnectBlockSubscribe = ({
  email,
  pinterestLink,
  instagramLink,
  facebookLink,
  linkedinLink,
}: ConnectBlockSubscribeType): JSX.Element => {
  return (
    <>
      {email && (
        <p className={style.paragraph}>
          <a className={style.link} href={`mailto:${email}`}>{email}</a>
        </p>
      )}
      <p className={style.paragraph}>
        <a className={style.link} href={instagramLink}>
          Instagram
        </a>
      </p>
      <p className={style.paragraph}>
        <a className={style.link} href={linkedinLink}>
          LinkedIn
        </a>
      </p>
    </>
  );
};
